import(/* webpackMode: "eager" */ "/root/services/fash-creative/src/app/privacy-policy/page.tsx")